import * as React from 'react'
import fetch from 'isomorphic-fetch'
import Repos from './Repos'
import Spinner from '../Spinner'

// Import Projects styling
import './Projects.css'

const Projects: React.FunctionComponent = () => {
  const [loading, setLoading] = React.useState<boolean>(true)
  const [repos, setRepos] = React.useState<object[]>([])

  React.useEffect(() => {
    fetch('https://api.github.com/users/swizzleee/repos')
      .then(res => res.json())
      .then(data => {
        setRepos(data)
        setLoading(false)
      })
  }, [])

  return (
    <div className="row" id="projects">
      <div className="side-content-sm"></div>
      <div className="main-content-lg">
        <div className="content-header">
          <a className="anchor"></a>
          <h2>Projects</h2>
          <p className="lead text-center">Below are a list of Public Repositories hosted on my <a href="https://github.com/sWiZZleee">GitHub</a></p>
        </div>
        <div className="content-body">
          <div className="row justify-content-md-center">
            {loading ? <Spinner /> : <Repos repos={repos}/>}
          </div>
        </div>
      </div>
      <div className="side-content-sm"></div>
    </div>
  )
}

export default Projects
